/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!******************************************!*\
  !*** ./src/assets/js/featured-brands.js ***!
  \******************************************/
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var FeaturedBrands = /*#__PURE__*/function () {
  function FeaturedBrands() {
    _classCallCheck(this, FeaturedBrands);

    this.selectors = {
      section: ".home-logo-sec",
      swiper: ".logoSwiper",
      thumbSwiper: ".logoSwiperText"
    };
    this.modificators = {
      active: "active"
    };
    this.activeSlider = null;
    this.activeThumbSlider = null;
  }

  _createClass(FeaturedBrands, [{
    key: "initSlider",
    value: function initSlider(slider, section) {
      if (this.activeSlider) {
        this.activeSlider.destroy();
      }

      var thumbSlider = section.querySelector(this.selectors.thumbSwiper);
      var pagination = section.querySelector('.swiper-pagination');
      var options = {
        centeredSlides: true,
        // loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        thumbs: {
          swiper: this.activeThumbSlider
        },
        grabCursor: true,
        breakpoints: {
          0: {
            slidesPerView: 2.5,
            spaceBetween: 66,
            initialSlide: 1
          },
          650: {
            slidesPerView: 3.5
          },
          1024: {
            slidesPerView: 5
          }
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true
        }
      };
      var thumbsOptions = {
        slidesPerView: 1,
        initialSlide: 1
      };
      this.activeThumbSlider = new Swiper(thumbSlider, thumbsOptions);
      this.activeSlider = new Swiper(slider, options);
      this.activeSlider.controller.control = this.activeThumbSlider;
      this.activeThumbSlider.controller.control = this.activeSlider;
    }
  }, {
    key: "handleSections",
    value: function handleSections() {
      var _this = this;

      var sections = document.querySelectorAll(this.selectors.section);
      if (!sections.length) return;
      sections.forEach(function (section) {
        var slider = section.querySelector(_this.selectors.swiper);

        _this.initSlider(slider, section);
      });
    }
  }]);

  return FeaturedBrands;
}();

document.addEventListener("DOMContentLoaded", function () {
  var featuredBrandsEvent = new FeaturedBrands();
  featuredBrandsEvent.handleSections();
  window.featuredBrandsEvent = featuredBrandsEvent;
});
/******/ })()
;